import React from 'react';
import { Typography } from 'fronton-react';
import { SearchEmptyIcon } from 'assets';
import { EmptyState, EmptyStateIconWrapper, EmptyStateText } from './styles';

export const SavedProjectsEmptyState = () => (
  <EmptyState data-testid="saved-projects-empty-state">
    <EmptyStateIconWrapper>
      <SearchEmptyIcon />
    </EmptyStateIconWrapper>
    <EmptyStateText>
      <Typography size="body_accent" variant="m" color="text-primary">
        У клиента пока нет сохранённых расчётов
      </Typography>
    </EmptyStateText>
  </EmptyState>
);
